<template>
<div @keydown.esc="$emit('closeAddPro', false)">
	<v-card class="d-flex flex-column">
		<v-progress-linear
			v-if="isSubmitting"
			indeterminate
			color="deepAqua"
			height="6"
		></v-progress-linear>
		<div class="d-flex">
			<div style="width:45%; max-height:80vh; overflow:hidden scroll">
				<v-tabs grow height="64px" color="#399942" background-color="transparent">
					<v-tab class="tab1" data-testid="gotoComment">概要</v-tab>
					<v-tab class="tab1" data-testid="gotoShusei">チャット</v-tab>
					<v-tab class="tab1">修正提案</v-tab>

					<!--概要-->
					<v-tab-item>
						<project_about :pjuid="pjuid" :aboutpj="aboutpj" :pjusers="pjusers" :pjadmins="pjadmins" style="max-height:90% !important"></project_about>
					</v-tab-item>

					<!--チャット-->
					<v-tab-item>
						<chat contentType="comments" :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins" @sanka="$emit('sanka')" :isPro="true"></chat>
					</v-tab-item>

					<!--修正提案-->
					<v-tab-item v-if="true||project_amdOpen">
						<chat contentType="amendments" :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins" @sanka="$emit('sanka')" :isPro="true" :amends="amends" @addAmends="addAmend"></chat>
					</v-tab-item>

				</v-tabs>
			</div>
			<div style="width:55%; max-height:80vh; overflow:hidden scroll">
				<div class="d-flex">
					<h2 class="mx-auto text-h5 text-center pt-4"><font color="#2B2B2B">修正案を記入してください</font></h2>
					<v-btn class="ml-auto" icon color="primary" @click="$emit('closeAddPro', false)"><v-icon color="#E64550">mdi-close</v-icon></v-btn>
				</div>
				<v-card flat class="pa-2">
					<RichEditor :key="pjuid" ref="editor" :defaultValue="pjan" />
				</v-card>
			</div>       
		</div>
		<!--フッター-->
		<v-card-actions>
			<v-btn class="text-h6 font-weight-bold " color="blue" @click="$emit('closeAddPro', false)" text hide-details>修正案の作成をやめる＜</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#008CFF" class="ideanext px-4 font-weight-bold rounded-pill white--text" @click="checkBeforeSubmit()" :disabled="isSubmitting" v-if="amends.length>0">作成完了</v-btn>
			<v-btn color="#008CFF" class="ideanext px-4 font-weight-bold rounded-pill white--text" @click="checkBeforeSubmit()" :disabled="isSubmitting" v-else>作成完了</v-btn>
		</v-card-actions>
	</v-card>

	<!--新案登録確認-->
	<v-dialog v-model="createProCheck" width="60%">
		<v-card>
			<v-img v-if="false" class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
			<p class="text-center pt-14 font-weight-bold px-8 py-4 text-h5">修正案を登録しますか？</p>
			<v-card-actions>
			<v-spacer></v-spacer>
			<v-chip class="ma-4 pa-4" color="#E64550" @click="createProCheck=false" dark>いいえ</v-chip>
			<v-chip class="ma-4 pa-4" color="#008CFF" @click="createProCheck=false, isSubmitting = true, submitpro()" :disabled="isSubmitting" dark>はい</v-chip>
			<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog v-model="createProCheck2" width="80%">
		<v-card>
			<v-img v-if="false" class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
			<p class="text-center pt-14 font-weight-bold px-8 py-4 text-h5">修正提案は何も採用していませんが、修正案を登録しますか？</p>
			<v-card-actions>
			<v-spacer></v-spacer>
			<v-chip class="ma-4 pa-4" color="#E64550" @click="createProCheck2=false" dark>いいえ</v-chip>
			<v-chip class="ma-4 pa-4" color="#008CFF" @click="createProCheck2=false, isSubmitting = true, submitpro()" :disabled="isSubmitting" dark>はい</v-chip>
			<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
	
	<!-- 案登録ボタン押下時に空だったら案内 -->
	<v-dialog v-model="createProWarnContentEmpty" width="70%">
		<v-card>
			<p class="text-center pt-14 font-weight-bold px-8 py-4 text-h5">修正提案が空です。入力してください。</p>
			<v-card-actions>
			<v-spacer></v-spacer>
			<v-chip class="ma-4 pa-4" color="#008CFF" @click="createProWarnContentEmpty=false" dark>閉じる</v-chip>
			<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<!--新案登録確認後-->
	<v-dialog v-model="createProCheckAfter" width="60%" persistent>
		<v-card>
			<v-img v-if="false" class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
			<p class="text-center pt-14 font-weight-bold px-8 py-4 text-h5">修正案を登録しました</p>
			<v-card-actions>
			<v-spacer></v-spacer>
			<v-chip class="ma-4 pa-4" @click="createProCheckAfter=false" color="#008CFF" dark>はい</v-chip>
			<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
    <activity_function ref="activityfunc" />
</div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/firestore"
import project_about from './project_about.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import activity_function from '../../components/profile/activity_function.vue'
import RichEditor from '../../components/RichEditor.vue';
import chat from './chat.vue'
export default{
	components:{
		RichEditor,
		project_about,
		activity_function,
		chat
	},
	props:{
		pjuid: String,
		aboutpj: Object,
		pjadmins: Array,
		pjusers: Array,
		pjan: String,
	},
	data: (vm) => ({
		currentName: firebase.auth().currentUser.displayName,
		uid: firebase.auth().currentUser.uid,
		offsetTop: 0,

		amends: [],
		//dialog
		createProCheck: false,
		createProCheck2: false,
		createProCheckAfter: false,
		createProWarnContentEmpty: false,

		isSubmitting: false,

		todayy: null,
		yyyy: null,
		mm: null,
		dd: null,

		required: v => !!v || "必ず入力してください",
		pjEditorOption: {
			modules: {
				toolbar: [
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				//[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
				['bold', 'italic', 'underline', 'strike'],        // toggled buttons
				//['blockquote', 'code-block'],
				//[{ 'header': 1 }, { 'header': 2 }],               // custom button values
				//[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				//[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
				//[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
				//[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
				//[{ 'font': [] }],
				[{ 'align': [] }],
				['image'],
				//['clean']                                         // remove formatting button
				]
			}
		},
		pjsuEditorOption:{
			modules: {
				toolbar: [
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				//[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
				['bold', 'italic', 'underline', 'strike'],        // toggled buttons
				//['blockquote', 'code-block'],
				//[{ 'header': 1 }, { 'header': 2 }],               // custom button values
				//[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				//[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
				//[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
				//[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
				//[{ 'font': [] }],
				[{ 'align': [] }],
				//['clean']                                         // remove formatting button
				]
			}
		},
	}),
  computed:{
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
  },
	mounted(){
		this.db = firebase.firestore() // dbインスタンスを初期化
	},
	methods: {
		onScroll (e) { //スクロール
			this.offsetTop = e.target.scrollTop
		},
		addAmend(el){
      let num = this.amends.indexOf(el)
      if(num == -1) this.amends.push(el)
      else this.amends.splice(num, 1)
      console.log("amends",this.amends)
    },
		checkBeforeSubmit() {
			if (this.$refs.editor.contentEditing.length) {
				this.createProCheck = true
			} else {
				this.createProWarnContentEmpty = true
			}
		},
		submitpro: async function(){ //案を登録する
			let self = this
			this.today()
			const lidId = this.$route.params.id
			await this.db.collection("0").doc(lidId).collection("project").doc(this.pjuid).collection("proposals").add({
				author: this.uid,
				currentName: this.currentName,
				createdAt: firebase.firestore.FieldValue.serverTimestamp(),
				updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
				sort: this.todayy,
				title: `${this.yyyy}-${this.mm}-${this.dd}`,
				amends: this.amends
			}).then(async function(docRef) {
				await self.$refs.editor.submitContent(`projects/${lidId}/${self.pjuid}/proposal/${docRef.id}.html`)
				// 保存に成功した時
				//console.log("proposals Document written with ID: ", docRef.id)
				//self.$router.push({ path: self.$route.path, query: { id: self.pjuid } })
				// 最初の50文字を抜き出す。imgタグは除外
				await self.$refs.activityfunc.proposals(self.$route.params.id,self.pjuid,docRef.id,self.$refs.editor.contentEditing.replace(/<img.*?>/g, '').slice(0, 50)||'alternative text')
			}).catch(function(error) {
				// 保存に失敗した時
				console.error("proposals Error adding document: ", error)
				alert("Error!:"+error)
			})
			this.$emit('closeAddPro', false),
			self.$emit("updateAn")
			this.createProCheckAfter = true
			this.isSubmitting = false

		},
		toDoubleDigits(num) {
			num += "";
			if (num.length === 1) {
				num = "0" + num;
			}
			return num; 
		},
		today(){
			// 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
			let date = new Date();
			let yyyy = date.getFullYear();
			let mm = this.toDoubleDigits(date.getMonth() + 1)
			let dd = this.toDoubleDigits(date.getDate())
			let hh = this.toDoubleDigits(date.getHours())
			let mi = this.toDoubleDigits(date.getMinutes())
			let se = this.toDoubleDigits(date.getSeconds())
			let ms = this.toDoubleDigits(date.getMilliseconds())
			this.todayy = yyyy + mm + dd + hh + mi + se + ms
			this.yyyy = yyyy
			this.mm = mm
			this.dd = dd	
		},
	}
}
</script>
<style scoped>
.ideanext{
  font-size: 1.5rem;
}
.tab1{
  font-weight: 800;
  width: 33%;
}
v-dialog{
	z-index: 700 !important;
}
* ::-webkit-scrollbar { 
  display: none;
}
*{
  font-family:mplus-2c-medium;
}
</style>